<template>
  <base-modal :open="open" size="lg" @close="cancel">
    <div slot="header">
      <button type="button" class="close" @click="cancel">
        <span>&times;</span>
      </button>
      <h3 class="modal-title">Search for HOD</h3>
    </div>

    <div class="content">
      <div v-if="loading" class="text-center col-md-4 col-md-offset-4 padding-bottom-20">
        <i class="fa fa-circle-o-notch fa-spin fa-fw fa-5x"></i>
      </div>

      <div v-else-if="!loading && hods.length">
        <div class="row">
          <p class="col-xs-8">
            <i class="glyphicon glyphicon-info-sign"></i> Search for your HOD.
          </p>
          <input-text name="filterText" label="Search" class="col-xs-4" v-model="filterText"></input-text>
        </div>

        <table class="table table-hover" v-if="filteredHods.length">
          <thead>
            <tr>
              <td>First Name</td>
              <td>Last Name</td>
              <td>Training Institution</td>
              <td>Speciality</td>
              <td class="text-right">Action</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="hod in filteredHods">
              <td>{{hod.user.name}}</td>
              <td>{{hod.user.surname}}</td>
              <td>{{hod.trainingInstitution}}</td>
              <td>{{hod.speciality}}</td>
              <td class="text-right"><button class="btn btn-default btn-lg" @click="select(hod)">Select</button></td>
            </tr>
          </tbody>
        </table>

        <p v-else class="text-center padding-bottom-20">
          No HOD's found
        </p>
      </div>

      <div>
        <p>
          Can't find the HOD you are looking for? Invite them to join.
        </p>

        <form @submit.prevent="invite">
          <div class="row">
            <input-text name="hodEmail" label="Email Address" class="col-xs-6" v-model="hodInvite.emailAddress" :validation="$v.hodInvite.emailAddress"></input-text>
            <input-text name="hodName" label="Name" class="col-xs-6" v-model="hodInvite.name" :validation="$v.hodInvite.name"></input-text>
          </div>

          <button type="submit" class="btn btn-primary pull-right">Invite</button>
        </form>
      </div>
    </div>
  </base-modal>
</template>

<script>
  import BaseModal from 'components/common/modals/BaseModal';

  import { required, email } from 'vuelidate/lib/validators';
  import { alphaWhite } from 'utils/validators';

  import { flatten } from 'utils/general';

  import InputText from 'components/common/inputs/InputText';

  export default {
    name: 'hod-search-modal',
    props: [
      'open',
      'specialityId',
      'trainingInstituteId',
    ],
    components: {
      BaseModal,
      InputText,
    },
    data: () => ({
      loading: false,
      errorMessage: '',
      filterText: '',
      hods: [],
      hodInvite: {
        emailAddress: '',
        name: '',
      },
    }),
    validations: {
      hodInvite: {
        emailAddress: {
          required,
          email,
        },
        name: {
          required,
          alphaWhite,
        },
      },
    },
    computed: {
      filteredHods() {
        const filterKey = this.filterText && this.filterText.toLowerCase();
        let data = this.hods;

        if (filterKey) {
          data = data.filter((row) => {
            const flatRow = flatten(row);

            // eslint-disable-next-line max-len
            return Object.keys(flatRow).some(key => String(flatRow[key]).toLowerCase().indexOf(filterKey) > -1);
          });
        }

        return data;
      },
    },
    methods: {
      async searchHods() {
        try {
          this.loading = true;
          this.hods = await this.$api.searchHods({
            searchTerm: this.filterText,
            speciality: this.specialityId,
            institute: this.trainingInstituteId,
          });
        } catch (error) {
          this.errorMessage = this.$api.processError(error);
        } finally {
          this.loading = false;
        }
      },
      select(hod) {
        this.$emit('close', {
          hod,
          hodInvite: undefined,
        });
      },
      invite() {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          this.$emit('close', {
            hod: undefined,
            hodInvite: this.hodInvite,
          });
        }
      },
      cancel() {
        this.$emit('close', {
          hod: undefined,
          hodInvite: undefined,
        });
      },
    },
    watch: {
      open(opening) {
        if (opening) {
          this.searchHods();
        } else {
          this.hods = [];
          this.filterText = '';
          this.hodInvite = {
            emailAddress: '',
            name: '',
          };
        }
      },
    },
  };

</script>



// WEBPACK FOOTER //
// HodSearchModal.vue?652af47a